import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ResumePage.css';

function ResumePage() {
  const navigate = useNavigate();

  return (
    <div className="resume-page">
      <button onClick={() => navigate(-1)} className="back-button">
        ← Back
      </button>
      <div className="resume-content">
        <h1>Resume</h1>
        <p>Resume page coming soon...</p>
      </div>
    </div>
  );
}

export default ResumePage;

